import React, { useId } from "react";

type FilePickerProps = {
  // 呼び出し側が input を id で探す場合だけ指定（一括取り込みのリセット処理など）
  id?: string;
  accept: string;
  multiple?: boolean;
  // 選んだファイルの表示（例: "cards.xlsx" / "3個のファイル"）。未選択なら null
  selectedText: string | null;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

// ファイル選択。ブラウザ標準の部品は英語表示（Choose File）で形もそろわないので、
// 本物の input は隠し、ラベルを副の操作のボタンとして見せる
const FilePicker: React.FC<FilePickerProps> = ({ id: givenId, accept, multiple = false, selectedText, onChange }) => {
  const generatedId = useId();
  const id = givenId ?? generatedId;
  return (
    <div className="filePicker">
      <input id={id} type="file" accept={accept} multiple={multiple} onChange={onChange} className="sr-only" />
      <label htmlFor={id} className="btn btn-secondary">ファイルを選択</label>
      <span className="filePicker__name">{selectedText ?? "選択されていません"}</span>
    </div>
  );
};

export default FilePicker;
